import React, { useState, useEffect } from "react";
// import AOS from 'aos';
// import 'aos/dist/aos.css';

function Icon({ id, open }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
    </svg>
  );
}

const Faq = () => {
  const [open, setOpen] = useState(null);

  const handleOpen = (value) => {
    setOpen(open === value ? null : value);
  };

  //   useEffect(() => {
  //     AOS.init({ duration: 1000 });
  //   }, []);

  return (
    <div className="bg-transparent   px-6 w-full md:w-[85%] mx-auto font-[poppins]">
      <div>
        <div className="flex flex-col justify-center items-center mb-9 md:mb-14">
          <h5 className="text-[16px] md:text-[24px] mb-3 font-bold text-gray-900 capitalize" data-aos='fade-up' data-aos-delay="50" data-aos-duration="1000">
            frequently asked question
          </h5>
          <p className="text-[12px] sm:text-[14px] md:text-[16px] md:mb-6 font-normal text-blue-gray-100 w-full md:w-[70%] text-center text-gray-800" data-aos='fade-up' data-aos-delay="100" data-aos-duration="1000">
            Explore our FAQ section for quick answers to commonly asked questions about our program.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-24 gap-y-8 md:gap-y-20">

        <div data-aos='fade-down-right' data-aos-delay="50" data-aos-duration="1000">
          <div className="bg-gray-50  rounded-md cursor-pointer" onClick={() => handleOpen(1)}>
            <div className="flex justify-between items-center text-[10px] sm:text-[14px] md:text-[14px] text-gray-900 px-3 py-4 font-semibold">
              What is the duration of the VFX course?
              <Icon id={1} open={open} />
            </div>
            {open === 1 && (
              <div className=" font-normal text-blue-gray-800  border-b border-gray-500 rounded-md px-3">
                <p className="text-gray-800  text-[10px] sm:text-[13px] md:text-[14px] font-normal pb-3">
                  The VFX course is a 1-year program.
                </p>
              </div>
            )}
          </div>
        </div>

        <div data-aos='fade-down-left' data-aos-delay="50" data-aos-duration="1000">
          <div className="bg-gray-50  rounded-md cursor-pointer" onClick={() => handleOpen(2)}>
            <div className="flex justify-between items-center text-[10px] sm:text-[14px] md:text-[14px] text-gray-900 px-3 py-4 font-semibold">
              What are the timings of the classes?
              <Icon id={2} open={open} />
            </div>
            {open === 2 && (
              <div className=" font-normal text-blue-gray-800  border-b border-gray-500 rounded-md px-3">
                <p className="text-gray-800 text-[10px] sm:text-[13px] md:text-[14px] font-normal pb-3">
                  Classes are held from 9:30 am to 5:00 pm, Monday to Friday.
                </p>
              </div>
            )}
          </div>
        </div>

        <div data-aos='fade-down-right' data-aos-delay="50" data-aos-duration="1000">
          <div className="bg-gray-50  rounded-md cursor-pointer" onClick={() => handleOpen(3)}>
            <div className="flex justify-between items-center text-[10px] sm:text-[14px] md:text-[14px] text-gray-900 px-3 py-4 font-semibold">
              What software will I learn in the VFX course?
              <Icon id={3} open={open} />
            </div>
            {open === 3 && (
              <div className=" font-normal text-blue-gray-800  border-b border-gray-500 rounded-md px-3">
                <p className="text-gray-800 text-[10px] sm:text-[13px] md:text-[14px] font-normal pb-3">
                  You will learn industry-standard software such as Nuke, Maya, and Adobe Creative Suite, Unreal Engine, among others.
                </p>
              </div>
            )}
          </div>
        </div>

        <div data-aos='fade-down-left' data-aos-delay="50" data-aos-duration="1000">
          <div className="bg-gray-50  rounded-md cursor-pointer" onClick={() => handleOpen(4)}>
            <div className="flex justify-between items-center text-[10px] sm:text-[14px] md:text-[14px] text-gray-900 px-3 py-4 font-semibold">
              What is the eligibility criteria for the VFX course?
              <Icon id={4} open={open} />
            </div>
            {open === 4 && (
              <div className=" font-normal text-blue-gray-800  border-b border-gray-500 rounded-md px-3">
                <p className="text-gray-800 text-[10px] sm:text-[13px] md:text-[14px] font-normal pb-3">
                  Candidates with a passion for visual effects and a minimum age of 18 years can apply.
                </p>
              </div>
            )}
          </div>
        </div>

        <div data-aos='fade-down-right' data-aos-delay="50" data-aos-duration="1000">
          <div className="bg-gray-50  rounded-md cursor-pointer" onClick={() => handleOpen(5)}>
            <div className="flex justify-between items-center text-[10px] sm:text-[14px] md:text-[14px] text-gray-900 px-3 py-4 font-semibold">
              Will I get hands-on training in the VFX course?
              <Icon id={5} open={open} />
            </div>
            {open === 5 && (
              <div className=" font-normal text-blue-gray-800  border-b border-gray-500 rounded-md px-3">
                <p className="text-gray-800 text-[10px] sm:text-[13px] md:text-[14px] font-normal pb-3">
                  Yes, our course focuses on practical training, and you will work on various projects to build your portfolio.
                </p>
              </div>
            )}
          </div>
        </div>

        <div data-aos='fade-down-left' data-aos-delay="50" data-aos-duration="1000">
          <div className="bg-gray-50  rounded-md cursor-pointer" onClick={() => handleOpen(6)}>
            <div className="flex justify-between items-center text-[10px] sm:text-[14px] md:text-[14px] text-gray-900 px-3 py-4 font-semibold">
              What is the fee structure for the VFX course?
              <Icon id={6} open={open} />
            </div>
            {open === 6 && (
              <div className=" font-normal text-blue-gray-800  border-b border-gray-500 rounded-md px-3">
                <p className="text-gray-800 text-[10px] sm:text-[13px] md:text-[14px] font-normal pb-3">
                  Please contact our admissions team for the latest fee information.
                </p>
              </div>
            )}
          </div>
        </div>

        <div data-aos='fade-down-right' data-aos-delay="50" data-aos-duration="1000">
          <div className="bg-gray-50  rounded-md cursor-pointer" onClick={() => handleOpen(7)}>
            <div className="flex justify-between items-center text-[10px] sm:text-[14px] md:text-[14px] text-gray-900 px-3 py-4 font-semibold">
              Will I get certification after completing the VFX course?
              <Icon id={7} open={open} />
            </div>
            {open === 7 && (
              <div className=" font-normal text-blue-gray-800  border-b border-gray-500 rounded-md px-3">
                <p className="text-gray-800 text-[10px] sm:text-[13px] md:text-[14px] font-normal pb-3">
                  Yes, upon successful completion of the course, you will receive a certificate from Cinema Factory Film Academy.
                </p>
              </div>
            )}
          </div>
        </div>

        <div data-aos='fade-down-left' data-aos-delay="50" data-aos-duration="1000">
          <div className="bg-gray-50  rounded-md cursor-pointer" onClick={() => handleOpen(8)}>
            <div className="flex justify-between items-center text-[10px] sm:text-[14px] md:text-[14px] text-gray-900 px-3 py-4 font-semibold">
              What kind of career opportunities are available after completing the VFX course?
              <Icon id={8} open={open} />
            </div>
            {open === 8 && (
              <div className=" font-normal text-blue-gray-800  border-b border-gray-500 rounded-md px-3">
                <p className="text-gray-800 text-[10px] sm:text-[13px] md:text-[14px] font-normal pb-3">
                  You can work as a VFX Supervisor, VFX Artist, Compositor, or 3D modeler, Animator, and many more such roles in the film, TV, or advertising industry.
                </p>
              </div>
            )}
          </div>
        </div>


        <div data-aos='fade-down-right' data-aos-delay="50" data-aos-duration="1000">
          <div className="bg-gray-50  rounded-md cursor-pointer" onClick={() => handleOpen(9)}>
            <div className="flex justify-between items-center text-[10px] sm:text-[14px] md:text-[14px] text-gray-900 px-3 py-4 font-semibold">
              What is the advantage of learning Unreal Engine in addition to VFX?
              <Icon id={9} open={open} />
            </div>
            {open === 9 && (
              <div className=" font-normal text-blue-gray-800  border-b border-gray-500 rounded-md px-3">
                <p className="text-gray-800 text-[10px] sm:text-[13px] md:text-[14px] font-normal pb-3">
                  Learning Unreal Engine will give you an edge in the industry, as it is currently widely used in film, TV, and game development.
                </p>
              </div>
            )}
          </div>
        </div>
        <div data-aos='fade-down-left' data-aos-delay="50" data-aos-duration="1000">
          <div className="bg-gray-50  rounded-md cursor-pointer" onClick={() => handleOpen(10)}>
            <div className="flex justify-between items-center text-[10px] sm:text-[14px] md:text-[14px] text-gray-900 px-3 py-4 font-semibold">
              How many students are in each batch?
              <Icon id={10} open={open} />
            </div>
            {open === 10 && (
              <div className=" font-normal text-blue-gray-800  border-b border-gray-500 rounded-md px-3">
                <p className="text-gray-800 text-[10px] sm:text-[13px] md:text-[14px] font-normal pb-3">
                  We maintain a small batch size to ensure personalized attention and mentorship.
                </p>
              </div>
            )}
          </div>
        </div>
        <div data-aos='fade-down-right' data-aos-delay="50" data-aos-duration="1000">
          <div className="bg-gray-50  rounded-md cursor-pointer" onClick={() => handleOpen(11)}>
            <div className="flex justify-between items-center text-[10px] sm:text-[14px] md:text-[14px] text-gray-900 px-3 py-4 font-semibold">
              What kind of faculty will be teaching the VFX course?
              <Icon id={11} open={open} />
            </div>
            {open === 11 && (
              <div className=" font-normal text-blue-gray-800  border-b border-gray-500 rounded-md px-3">
                <p className="text-gray-800 text-[10px] sm:text-[13px] md:text-[14px] font-normal pb-3">
                  Our faculty consists of industry professionals with years of experience in VFX and filmmaking.
                </p>
              </div>
            )}
          </div>
        </div>
        <div data-aos='fade-down-left' data-aos-delay="50" data-aos-duration="1000">
          <div className="bg-gray-50  rounded-md cursor-pointer" onClick={() => handleOpen(12)}>
            <div className="flex justify-between items-center text-[10px] sm:text-[14px] md:text-[14px] text-gray-900 px-3 py-4 font-semibold">
              What kind of infrastructure and facilities are available for students?
              <Icon id={12} open={open} />
            </div>
            {open === 12 && (
              <div className=" font-normal text-blue-gray-800  border-b border-gray-500 rounded-md px-3">
                <p className="text-gray-800 text-[10px] sm:text-[13px] md:text-[14px] font-normal pb-3">
                  Our academy is equipped with state-of-the-art computers, software, and equipment to provide a world-class learning experience.
                </p>
              </div>
            )}
          </div>
        </div>


      </div>
    </div>
  );
};

export default Faq;
